import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel, IconButton, Icon, Message } from 'rsuite'
import AttachFilesForm from '../../attachfiles/AttachFilesForm'
import AttachFilesView from '../../attachfiles/AttachFilesView'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import EditButton from '../../../components/buttons/editButton/EditButton'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import { getCPAForm, saveCPA, deleteCPA, downloadCPA } from '../../../redux/actions/withdrawRequest'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getSchemaSidebar } from '../../../redux/actions/sidebar'
import ButtonPanel from '../../ButtonPanel'
import {
  getExpendingForm,
  saveExpending,
  deleteExpending,
  downloadExpending,
  getWithdrawRequestForm,
} from '../../../redux/actions/withdrawRequest'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'

export default function ExpenditureReportWidget({ schema: _schema, ...props }) {
  const { showCommandButton, isEditAll, onSuccess, isRequiredCPA } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [isEdit, setIsEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [isEditErr, setIsEditErr] = useState(false)
  const [isUploadErr, setIsUploadErr] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(_schema)
  const [requestId, setRequestId] = useState('')

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    setFormSchema(_schema)
    console.log(_schema)
  }, [_schema])

  useEffect(() => {
    setIsEdit(isEditAll)
  }, [isEditAll])

  useEffect(() => {
    // let requestId = location.search.substring(1)
    let requestId = sessionStorage.getItem('param')?.substring(1)
    console.log('WithdrawRequestWidget', 'request_id: ', requestId)
    if (requestId) {
      setRequestId(requestId)
    }
  }, [location.search])

  const handleUpdate = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsEditErr()
    try {
      console.log('update')
      // const response = await updateAttachments(projectId, request)

      // console.log('response', response)

      // if (response) {
      //   let _schema = formSchema
      //   _schema.attachFiles = response
      //   setIsEditErr(false)
      //   setFormSchema(_schema)
      // } else {
      //   setIsEditErr(true)
      // }
    } catch (e) {
      console.log('e', e)
      setIsEditErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleUpload = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsUploadErr()
    try {
      console.log('upload')
      const response = await saveExpending(projectId, requestId, request)
      console.log('response', response)

      if (response) {
        // let _schema = formSchema
        // _schema.attachFiles = response
        setFormSchema((state) => ({
          ...state,
          attachFiles: {
            ...state.attachFiles,
            value: response,
          },
        }))
        setIsUploadErr(false)
        onSuccess(response)
      } else {
        setIsUploadErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsUploadErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (item) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError()
    try {
      console.log('call delete.')
      const status = await deleteExpending(projectId, requestId, item.id)
      if (status === 200) {
        console.log('call get.')
        const response = await getWithdrawRequestForm(projectId, requestId)
        console.log('getWithdrawRequestForm response', response.forms.expendingReport)
        if (response) {
          setFormSchema(response.forms.expendingReport)
          setIsDeleteError(false)
          onSuccess(response.forms.expendingReport.attachFiles.value)
        }
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    startLoading()
    var file = await downloadExpending(projectId, requestId, fileObj.id)

    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    var file = await downloadExpending(projectId, requestId, fileObj.id)

    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.setAttribute('value', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onUpload = (data) => {
    console.log('onSubmit data', data)
    const file = data[formSchema.attachFiles.name]
    var formData = new FormData()

    file?.forEach((element) => {
      formData.append('files', element.blobFile)
    })

    handleUpload(formData)
  }

  const onUpdate = (file, newName) => {
    console.log('onUpdate file', file, 'newName: ', newName)

    file['projectVersionId'] = projectId
    file['userId'] = 111
    file.label = newName

    console.log('file', file)
    //handleUpdate(file)
  }

  const onDelete = (index) => {
    let datas = [...formSchema.attachFiles.value]
    handleDelete(datas[index])
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      bordered
      collapsible
      defaultExpanded
      style={{ marginBottom: '1em' }}
      ref={(section) => {
        setSection(section)
      }}
    >
      {/* {isRequiredCPA && <Message showIcon type="warning" description={`กรุณาแนบไฟล์ ใบรับรองการใช้จ่ายเงินโครงการ(CPA) เพิ่มเติม`} />} */}

      {isEdit ? (
        <AttachFilesForm
          schema={formSchema.attachFiles}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          onSubmit={handleSubmit(onUpload)}
          onDelete={onDelete}
          onUpdate={onUpdate}
          onDownload={onDownload}
          onPreview={onPreview}
          isEditErr={isEditErr}
          isUploadErr={isUploadErr}
          isDeleteError={isDeleteError}
          loading={isLoading}
          // disabledUpload={formSchema.attachFiles.value.length > 0}
          disabledEdit={true}
        />
      ) : (
        <AttachFilesView
          schema={formSchema.attachFiles}
          onDownload={onDownload}
          onPreview={onPreview}
        />
      )}

      {showCommandButton && (
        <>
          <hr />

          {!isEdit && showCommandButton && (
            <EditButton
              onClick={() => {
                setIsEdit(!isEdit)
                setIsEditErr(false)
                setIsDeleteError(false)
                setIsUploadErr(false)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
              disabled={isLoading}
            >
              {'เพิ่ม/แก้ไข' + (formSchema.buttonText ? formSchema.buttonText : '')}
            </EditButton>
          )}

          {isEdit && (
            <div>
              <ViewButton
                icon="backward"
                onClick={() => {
                  setIsEdit(!isEdit)
                  setIsEditErr(false)
                  setIsDeleteError(false)
                  setIsUploadErr(false)
                  scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                }}
                disabled={isLoading}
              >
                {'ดูรายการ' + (formSchema.buttonText ? formSchema.buttonText : '')}
              </ViewButton>
            </div>
          )}
        </>
      )}
    </Panel>
  )
}
